/* eslint-disable */
import axios from "axios";

// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8000";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://www.xcelioncore.pv.tatamotors";


export const saveLogToBackend = async (logData) => {
  try {
    await axios.post(`${API_BASE_URL}/api/save_log_data`, logData, {
      headers: { "Content-Type": "application/json" },
    });
  } catch (err) {
    console.error("Failed to save log:", err);
  }
};
